import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import View from 'view/base';

var Project_Access_Select = View.extend({
    project_ids: [],

    events: {
        'click .project-item' : 'addProject',
        'click .delete'       : 'deleteProject'
    },

    dom_handlers: {
        addProject: function(e) {
            e.stopPropagation();

            var project_id = parseInt($(e.currentTarget).data('id'), 10);
            var index = this.project_ids.indexOf(project_id);

            if (index === -1) {
                this.project_ids.push(project_id);
            } else {
                this.project_ids.splice(index, 1);
            }

            this.render();
        },

        deleteProject: function(e) {
            if (this.project_ids.length <= 1) {
                return;
            }

            var project_id = parseInt($(e.currentTarget).data('id'), 10);
            var index = this.project_ids.indexOf(project_id);

            if (index !== -1) {
                this.project_ids.splice(index, 1);
                this.render();
            }
        }
    },

    initialize: function() {
        var projects = Cache.project.where({is_archived: false});

        if (projects.length === 1) {
            this.project_ids = [projects[0].id];
        } else {
            this.project_ids = [];
        }
    },

    renderProjectList: function() {
        var list = '';

        _.each(this.project_ids, function(project_id) {
            list += '<span class="badge-primary-invert margin-right-4 margin-bottom-4 font-weight-medium' + (this.project_ids.length > 1 ? ' badge-btn' : '') + '">' + Cache.project.get(project_id).escape('name');

            if (this.project_ids.length > 1) {
                list += '<button type="button" class="delete" data-id="' + project_id + '"><i class="far fa-times"></i></button>';
            }

            list += '</span>';
        }, this);

        this.$el.find('.project-list-region').html(list);
    },

    render: function() {
        var content = '';
        var dropdown_options = '';

        var projects = Cache.project.where({is_archived: false});

        projects.forEach((project) => {
            var is_selected = this.project_ids.indexOf(project.id) !== -1;
            dropdown_options +=
            '<li class="project-item' + (is_selected ? ' selected' : '') + '" data-id="' + project.id + '">' +
                '<div class="flex-start">' +
                    (project.get('logo') ?
                    '<span class="project-logo-icon-tiny" style="background-image:url(' + project.escape('logo') + ');"></span>' :
                    '<span class="project-type-icon-tiny" data-val="' + (project.isFeedback() ? 'feedback' : 'survey') +'"></span>') +
                    '<span class="ellipsis margin-left-8">' + project.escape('name') + '</span>' +
                '</div>' +
            '</li>';
        });

        content += '<span class="project-list-region"></span>';

        content += '<div class="button-dropdown button-dropdown-up button-dropdown-large">' +
                        '<button type="button" class="inline-add tooltip" data-title="Add a project"><i class="far fa-plus"></i></button>' +
                        '<div>' +
                            (projects.length >= 10 ?
                            '<div class="dropdown-search"><input type="text" class="solid compact" placeholder="Search by project name"></div>' : '')+
                            (dropdown_options ?
                            '<ul class="dropdown dropdown-select">' + dropdown_options + '</ul>' :
                            '<ul class="dropdown"><li class="disabled">No projects</li></ul>') +
                        '</div>' +
                    '</div>';

        content += '<input type="hidden" name="project_ids" value="' + this.project_ids.join(',') + '">';

        this.$el.html(content);
        this.renderProjectList();

        return this;
    }
});

export default Project_Access_Select;
